// Видеофон секции преимуществ на главной (вперёд → назад → вперёд, без обычного loop)

export const HomeAdvantagesVideoConfig = {
  sectionSelector: '.home-advantages',
  videoSelector: '.home-advantages__video-bg .home-advantages__video',
  timeEpsilon: 1 / 24,
  nativeReverseWatchMs: 220,
  /** Шаг назад по таймлайну (сек); один seek за раз (пока video.seeking — ждём) */
  reverseStepSeconds: 0.075,
};
